const validateUser = (user) => {
  if (!user) {
    return false;
  }
  if (user.username === undefined) {
    return false;
  }
  if (user.is_superuser === undefined) {
    return false;
  }
  if (user.is_staff === undefined) {
    return false;
  }
  if (user.token === undefined) {
    return false;
  }
  if (user.remember === undefined) {
    return false;
  }
  if (user.settings === undefined) {
    return false;
  }
  if (user.settings.default_event_type === undefined) {
    return false;
  }
  if (user.settings.default_bet_input === undefined) {
    return false;
  }
  if (user.settings.display_currency === undefined) {
    return false;
  }
  return true;
};

export default validateUser;
